export default __webpack_public_path__ + "static/media/google-play-badge-ENG.18a6c511.png";